import axios from "axios";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            agendaItemsOptions: [],
            agendaPathResource: "/agende",
            agendaAppuntamentiPathResource: "",

        };
    },
    methods: {
        agendeLoadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.agendaPathResource;
            this.openShowModalLoading();
            axios.get(link)
                .then((response) => {
                    this.agendaItemsOptions = response.data.data;
                    this.closeShowModalLoading();
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                    this.closeShowModalLoading();
                });
        }
    },
};
